export default __webpack_public_path__ + "static/media/sign in expert2.432541b2.png";